import React, { createContext, useContext, useMemo } from 'react';

type CodeStylesType = {
  hideHeaderInSingleLine: boolean;
  /*
    if fullHeight = true, no maxHeight will be applied
  */
  fullHeight: boolean;
};

const defaultHideHeaderInSingleLine = false;
const defaultFullHeight = false;

const CodeStylesContext = createContext<CodeStylesType>({
  hideHeaderInSingleLine: defaultHideHeaderInSingleLine,
  fullHeight: defaultFullHeight,
});
CodeStylesContext.displayName = 'CodeStyles';

export const CodeStylesProvider: React.FC<React.PropsWithChildren<Partial<CodeStylesType>>> = ({
  children,
  hideHeaderInSingleLine = defaultHideHeaderInSingleLine,
  fullHeight = defaultFullHeight,
}) => {
  const contextValue = useMemo(() => {
    return {
      hideHeaderInSingleLine,
      fullHeight,
    };
  }, [hideHeaderInSingleLine, fullHeight]);

  return <CodeStylesContext.Provider value={contextValue}>{children}</CodeStylesContext.Provider>;
};

export const useCodeStyles = () => {
  return useContext(CodeStylesContext);
};

export default CodeStylesProvider;
